<template>
  <Transition name="cookie-notice">
    <aside
      v-if="visible"
      class="cookie-notice tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-[1100] tw-p-3 sm:tw-p-6"
      aria-label="Pemberitahuan cookie"
      role="region"
    >
      <section
        class="cookie-notice__panel tw-mx-auto tw-flex tw-max-w-5xl tw-flex-col tw-gap-5 tw-rounded-2xl tw-border tw-border-[#dce8dc] tw-bg-white tw-p-5 sm:tw-flex-row sm:tw-items-center sm:tw-gap-6 sm:tw-px-7 sm:tw-py-6"
      >
        <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-start tw-gap-4">
          <div class="tw-grid tw-h-12 tw-w-12 tw-shrink-0 tw-place-items-center tw-rounded-full tw-bg-[#e9f3e8] tw-text-[#036419]">
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
              class="tw-h-6 tw-w-6"
            >
              <path
                d="M20.2 13.1A8.6 8.6 0 0 1 10.9 3.8a8.7 8.7 0 1 0 9.3 9.3Z"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <circle cx="8.2" cy="9.2" r="1" fill="currentColor" />
              <circle cx="12" cy="15.8" r="1" fill="currentColor" />
              <circle cx="7.1" cy="15" r=".8" fill="currentColor" />
            </svg>
          </div>

          <div class="tw-min-w-0">
            <h2 class="tw-mb-1 tw-text-base tw-font-bold tw-text-[#173b22] sm:tw-text-lg">
              Informasi penggunaan cookie
            </h2>
            <p class="tw-mb-0 tw-max-w-2xl tw-text-sm tw-leading-6 tw-text-slate-600">
              Situs kami menggunakan cookie untuk meningkatkan pengalaman Anda. Silakan menyetujui
              <a
                href="https://diskominfo.jogjaprov.go.id/kebijakan"
                target="_blank"
                rel="noopener noreferrer"
                class="tw-font-semibold tw-text-[#036419] tw-underline tw-decoration-[#ec9f12] tw-underline-offset-4 hover:tw-text-[#014a11] focus-visible:tw-rounded-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-[#036419]"
              >Pemberitahuan Privasi</a>
              untuk pengalaman terbaik.
            </p>
          </div>
        </div>

        <div class="tw-flex tw-shrink-0 tw-justify-end tw-gap-2 sm:tw-gap-3">
          <button
            type="button"
            class="cookie-notice__button cookie-notice__button--quiet"
            @click="defer"
          >Nanti</button>
          <button
            type="button"
            class="cookie-notice__button cookie-notice__button--primary"
            @click="continueToPrivacy"
          >Lanjutkan</button>
        </div>
      </section>
    </aside>
  </Transition>
</template>

<script>
export default {
  name: "CookieNotice",
  data() {
    return { visible: false };
  },
  mounted() {
    this.visible = !this.$cookies.get("cookie_notice");
  },
  methods: {
    defer() {
      this.$cookies.set("cookie_notice", "later", "1d", "/");
      this.visible = false;
    },
    continueToPrivacy() {
      this.$cookies.set("cookie_notice", "continued", "7d", "/");
      this.visible = false;
      this.$router.push({ name: "privacyPolicy" });
    },
  },
};
</script>

<style scoped>
.cookie-notice {
  background: linear-gradient(180deg, transparent 0%, rgb(20 42 24 / 8%) 100%);
}

.cookie-notice__panel {
  border-top: 3px solid #ec9f12;
  box-shadow: 0 18px 48px rgb(19 47 26 / 18%);
}

.cookie-notice__button {
  min-height: 44px;
  border-radius: 0.75rem;
  padding: 0.65rem 1.1rem;
  font-size: 0.875rem;
  font-weight: 700;
  transition: background-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.cookie-notice__button:focus-visible {
  outline: 3px solid #ec9f12;
  outline-offset: 3px;
}

.cookie-notice__button:active {
  transform: translateY(1px);
}

.cookie-notice__button--quiet {
  border: 1px solid #d5dfd5;
  background: #fff;
  color: #33483a;
}

.cookie-notice__button--quiet:hover {
  background: #f4f8f3;
}

.cookie-notice__button--primary {
  border: 1px solid #d48c08;
  background: #ec9f12;
  color: #203016;
}

.cookie-notice__button--primary:hover {
  background: #f4ae2d;
}

.cookie-notice-enter-active,
.cookie-notice-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.cookie-notice-enter-from,
.cookie-notice-leave-to {
  opacity: 0;
  transform: translateY(1rem);
}

@media (prefers-reduced-motion: reduce) {
  .cookie-notice__button,
  .cookie-notice-enter-active,
  .cookie-notice-leave-active {
    transition: none;
  }
}

@media (max-width: 639px) {
  .cookie-notice__button {
    flex: 1;
  }
}
</style>
